import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import exact from 'prop-types-exact';
import Button from '../button/Button';
import Spinner from '../Spinner/Spinner';
import { getAffiliatesDataIfNeeded } from '../../components/affiliates/actions/affiliatesAction';


class ButtonFrequencys extends Component {
    constructor() {
        super();

        this.state = {
            isOpen: false,
        };

        this.openModal = this._toggleModal.bind(this);
    }

    _toggleModal() {
        if (this.props.dataAffiliates.length < 1) {
            this.props.getAffiliatesDataIfNeeded();
        }

        this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
    }

    render() {
        return ([
            <div className="frequencys" key="0">
                <Button to="/afiliadas" title="Conheça as frequências">
                    Conheça a frequência FM da sua cidade
                    <FontAwesomeIcon className="tw-ml-1" icon={faChevronRight} />
                </Button>
            </div>,
            <ReactModal
                isOpen={this.state.isOpen}
                onRequestClose={this.openModal}
                contentLabel="Modal Frequências"
                className="modalFM"
                overlayClassName="overlayModalFM"
                closeTimeoutMS={250}
                key="1"
            >
                <div className="contentModal">
                    <div className="containerClose">
                        <Button title="fechar" onClick={this.openModal}>
                            <FontAwesomeIcon icon={faTimes} width="16" />
                        </Button>
                    </div>
                    <h2>Sintonize no FM</h2>
                    <p>Veja qual o dial da sua cidade</p>
                    <div className="contentFrequencys">
                        <div className="frequencyListScroll">
                            {this.props.dataAffiliates.length > 0 ?
                                <ul>
                                    {this.props.dataAffiliates.map((data) => (
                                        <li key={data.filial}>
                                            {data.filial}
                                        </li>
                                    ))}
                                </ul>
                                : <Spinner />}
                        </div>
                    </div>

                    <div className="knowMoreAffiliates">
                        <Button to="/afiliadas" title="Conheça as nossas filiais" onClick={() => this.setState({ isOpen: false })}>
                            Conheça as nossas filiais
                        </Button>
                    </div>
                </div>
            </ReactModal>]
        );
    }
}

ButtonFrequencys.propTypes = exact({
    dataAffiliates: PropTypes.array,
    getAffiliatesDataIfNeeded: PropTypes.func.isRequired,
});

const mapStateToProps = (state) => ({
    dataAffiliates: state.affiliates.dataAffiliates,
});

const mapDispatchToProps = (dispatch) => ({
    getAffiliatesDataIfNeeded: () => {
        dispatch(getAffiliatesDataIfNeeded());
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ButtonFrequencys);
